/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureCloudCounts {
    getFixupPrototypeFunction() { return OperationPostureCloudCounts.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureCloudCounts>): OperationPostureCloudCounts {
        let obj = Object.assign(new OperationPostureCloudCounts(), model);
        OperationPostureCloudCounts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureCloudCounts>): OperationPostureCloudCounts {
        if (!model) return null;
        return OperationPostureCloudCounts.newInstance(<OperationPostureCloudCounts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureCloudCounts) {
        if (!obj) return;

        models.OperationPostureCloudCounts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureCloudCounts): boolean {
        Object.setPrototypeOf(obj, OperationPostureCloudCounts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.GCP === undefined) {
            this.GCP = 0;
        }
        if (this.AWS === undefined) {
            this.AWS = 0;
        }
        if (this.azure === undefined) {
            this.azure = 0;
        }
        if (this.OCI === undefined) {
            this.OCI = 0;
        }
    }

    /**
     * GCP count
     */
    GCP: number;

    /**
     * AWS count
     */
    AWS: number;

    /**
     * Azure count
     */
    azure: number;

    /**
     * OCI count
     */
    OCI: number;

}
